/**
 * Wire contract for the admin payouts LIST surface (AUT-117 /
 * PHASE-B-API-6):
 *
 *   - `GET /admin/payouts` → `ListAdminPayoutsResultDto`
 *
 * Centralised in `@carcheck/shared` so the api + admin SPA import the
 * same source of truth — no api↔admin mirror drift.
 *
 * PII discipline (architect 🟠 #5 — AUT-117): `inspectorName` carries
 * REDACTED initials when the calling admin lacks `view_pii`. Customer
 * identity is NEVER exposed on this surface (payouts are inspector-side).
 * The `piiRevealed` flag tells the SPA which variant it received so it
 * never re-redacts a full value or renders a redacted value as copyable.
 * The server is the sole authority on redaction.
 *
 * All `Date` fields are ISO-8601 strings (JSON has no `Date`); consumers
 * convert at the render boundary via `new Date(dto.createdAt)`.
 */
/**
 * Admin-facing payout status — the THREE wire-stable values (architect lock
 * + Igor decision #3 2026-05-28). Wire intentionally drops dead enum
 * variants from the Prisma `PayoutStatus` enum (`scheduled`, `processing`,
 * `superseded`):
 *
 *   - `pending` — created, awaiting WebPay notifier confirmation
 *   - `completed` — notifier confirmed OR admin manually settled
 *   - `failed` — WebPay rejected OR notifier signalled failure
 *
 * Internal-only Prisma states (`scheduled` + `processing` are unused by
 * any code path; `superseded` is the AUT-117 retry-internal marker that
 * surfaces on the OLD row only — the new replacement row carries
 * `pending`). The list endpoint filters those rows out by default at the
 * service layer.
 *
 * Single source of truth for the api's filter Zod schema too — the api
 * imports `ADMIN_PAYOUT_STATUSES` rather than hand-typing the 3 values.
 */
export const ADMIN_PAYOUT_STATUSES = ['pending', 'completed', 'failed'];
/**
 * Payout rail discriminator. Mirror of the Prisma `Payout.rail` column.
 * AUT-91/92 deferred `mtbank_p2p` (vendor `recurring_bind` blocker); in
 * production only `oct` exists today. The server projects whatever the
 * DB row holds, so the wire union is intentionally minimal — when AUT-91
 * unpauses, the wire enum can be widened additively without breaking
 * existing clients (`AdminPayoutRail` is a string union so an unknown
 * value renders as-is on the SPA).
 */
export const ADMIN_PAYOUT_RAILS = ['oct'];
//# sourceMappingURL=admin-payout-list.js.map